module.exports = __webpack_public_path__ + "img/logorgb.10c1cdc3.svg";